<template>
  <div class="guangfu-tongyi">
    <div class="con">
      <div class="Files-top">
        <div class="ic-left">
          <span>发电效率</span>
        </div>
        <div class="btns">
          <el-button type="primary" class="last-el-button">导出</el-button>
        </div>
      </div>
      <div class="search-input-btn" style="width:100%">

        <div class="input-small myinput mr-20">
          <span>周期：</span>
          <el-select v-model="value" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="input-small ">
          <span>时间：</span>
          <el-date-picker v-model="value2" :type="value" placeholder="选择时间">
          </el-date-picker>
        </div>
        <el-button type="primary" plain class="search-btn">查询</el-button>
      </div>
      <div class="myteble">
        <el-table :data="tableData" stripe style="width: 100%" :height="heights">
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="站点"> </el-table-column>
          <el-table-column prop="timer" label="时间"> </el-table-column>
          <el-table-column prop="value" label="发电量(kwh)"> </el-table-column>
          <el-table-column prop="xiaolv" label="发电效率"> </el-table-column>
          <el-table-column prop="tongbi" label="同比" align="center"> </el-table-column>
          <el-table-column prop="huanbi" label="环比" align="center"> </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'WedoWebEleEfficiency',

    data () {
      return {
        tableData: [
          {
            'name': "珠海设备",
            'timer': "6-15",
            'value': "1800",
            'xiaolv': "123%",
            'tongbi': "0.00%",
            'huanbi': "16.33%",
          },
          {
            'name': "珠海设备",
            'timer': "6-16",
            'value': "1816",
            'xiaolv': "130.26%",
            'tongbi': "0.00%",
            'huanbi': "0.94%",
          },
          {
            'name': "珠海设备",
            'timer': "6-17",
            'value': "1920",
            'xiaolv': "137.25%",
            'tongbi': "0.00%",
            'huanbi': "5.18%",
          },
          {
            'name': "珠海设备",
            'timer': "6-18",
            'value': "352",
            'xiaolv': "78%",
            'tongbi': "0.00%",
            'huanbi': "61.99%",
          },
          {
            'name': "珠海设备",
            'timer': "6-19",
            'value': "1108",
            'xiaolv': "101.28%",
            'tongbi': "0.00%",
            'huanbi': "135.82%",
          },
          {
            'name': "珠海设备",
            'timer': "6-20",
            'value': "3851",
            'xiaolv': "303%",
            'tongbi': "0.00%",
            'huanbi': "5.6%",
          },
          {
            'name': "珠海设备",
            'timer': "6-21",
            'value': "2610",
            'xiaolv': "200%",
            'tongbi': "0.00%",
            'huanbi': "26.21%",
          },
          {
            'name': "珠海设备",
            'timer': "6-22",
            'value': "852",
            'xiaolv': "135.39%",
            'tongbi': "0.00%",
            'huanbi': "48.21%",
          },
          {
            'name': "珠海设备",
            'timer': "6-23",
            'value': "468.58",
            'xiaolv': "15.24%",
            'tongbi': "0.00%",
            'huanbi': "58.15%",
          },
          {
            'name': "珠海设备",
            'timer': "6-24",
            'value': "987",
            'xiaolv': "25.64%",
            'tongbi': "0.00%",
            'huanbi': "12.64%",
          },
          {
            'name': "珠海设备",
            'timer': "6-25",
            'value': "246",
            'xiaolv': "25.64%",
            'tongbi': "0.00%",
            'huanbi': "12.64%",
          },
          {
            'name': "珠海设备",
            'timer': "6-26",
            'value': "1205.15",
            'xiaolv': "78.19%",
            'tongbi': "0.00%",
            'huanbi': "35.21%",
          },
          {
            'name': "珠海设备",
            'timer': "6-27",
            'value': "1263.54",
            'xiaolv': "128.65%",
            'tongbi': "0.00%",
            'huanbi': "13.54%",
          },
        ],
        value2: new Date(),
        options: [{
          value: 'date',
          label: '日'
        },{
          value: 'month',
          label: '月'
        },{
          value: 'year',
          label: '年'
        }],
        value: 'date',
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
      };
    },

    mounted () {

    },

    methods: {

    },
  };
</script>

<style lang="scss" scoped>
  .guangfu-tongyi {}
</style>